import React from 'react';
export var usePreventDefaultHandler = handler => React.useMemo(() => {
  if (typeof handler !== 'function') {
    return handler;
  }

  // @ts-expect-error handler expects only 1 parameter (e), but our users might be using more
  var preventDefaultHandler = function (e) {
    var _e$preventDefault;
    e === null || e === void 0 ? void 0 : (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 ? void 0 : _e$preventDefault.call(e);

    // @ts-expect-error handler expects a fixed number of parameters (1 event), but we also pass rest of props
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    handler(e, ...rest);
  };
  return preventDefaultHandler;
}, [handler]);
//# sourceMappingURL=index.js.map